/**
 * @expFlag auth-mobile-redirect-app-main-actions
 * @ticket CLOUDWEB-20237
 * @file
 */

export const AUTH_MOBILE_REDIRECT_APP_MAIN_ACTIONS_SHOWN = 'MOBILE_REDIRECT_MAIN_ACTIONS_SHOWN';

/**
 * @expFlag promo-in-webview-public
 * @ticket CLOUDWEB-20374
 * @start
 */
export enum ERedirectPromoElement {
    banner = 'banner',
    snackbar = 'snackbar',
    promoBlock = 'promo_block',
}
/**
 * @expFlag promo-in-webview-public
 * @ticket CLOUDWEB-20374
 * @end
 */
